module.exports = __webpack_public_path__ + "img/airdrop.b144957f.png";